// extracted by mini-css-extract-plugin
module.exports = {"star":"StarToggle--star--85yi2"};